import { useEffect, useState } from "react";
import QRCode from "qrcode";

// otpauth:// 주소를 QR 로 그린다. 브라우저 안에서 그린다(qrcode, MIT) — 폐쇄망이라
// 바깥 요청이 없어야 하고, 비밀이 든 주소를 어디로도 보내면 안 된다.
export function TotpQr({ uri, size = 200 }: { uri: string; size?: number }) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    setSrc(null);
    QRCode.toDataURL(uri, { margin: 1, width: size, errorCorrectionLevel: "M" })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {
        if (!cancelled) setSrc(null);
      });
    return () => {
      cancelled = true;
    };
  }, [uri, size]);

  return (
    <div className="mtotp-qr">
      {src ? <img src={src} alt="인증 앱 등록 QR" width={size} height={size} /> : <span className="mtotp-note">QR 을 준비하는 중…</span>}
    </div>
  );
}
